import { useAtomValue } from "jotai";
import React from "react";

import { CloseIcon } from "~/components/ui/icons/close";
import { Logo } from "~/components/ui/logo";
import { brandState } from "~/stores/brand";

export type XChooseHeaderProps = {
  brandName?: string;
  children?: React.ReactNode;
};

export const XChooseHeader: React.FC<XChooseHeaderProps> = ({
  brandName,
  children,
}: XChooseHeaderProps) => {
  const brand = useAtomValue(brandState);

  return (
    <header className="items-center justify-between sm:flex">
      <div className="mb-4 flex items-center sm:mb-0">
        <Logo role="img" aria-label="Logo Choose" />
        <CloseIcon className="ml-2 size-3 text-gray-500" />
        <p className="m-0 ml-1 text-base text-gray-900">
          {brandName ?? brand?.name ?? ""}
        </p>
      </div>
      {children}
    </header>
  );
};

XChooseHeader.displayName = "XChooseHeader";
